export default "__VITE_ASSET__C50vlN____"